import { Receipt } from "lucide-react";
import { fmtDate, fmtRelative } from "@/lib/supervisorFormat";

/**
 * Compact «Local Agent» presence cell for the Tenants table.
 * Shows a coloured dot, last-poll relative time and today's fiscal
 * receipt count in a single narrow column.
 */
export default function AgentStatusCell({ tenant }) {
  const status = tenant.agent_status || "offline";
  const isOnline = status === "online";
  const lastPoll = tenant.last_agent_poll_at;
  const lastReceipt = tenant.last_fiscal_receipt_at;
  const receiptsToday = tenant.fiscal_receipts_today || 0;
  const dotColor = isOnline ? "bg-emerald-500" : (lastPoll ? "bg-rose-500" : "bg-zinc-600");
  const ringColor = isOnline ? "shadow-emerald-500/60" : "shadow-rose-500/40";
  const label = isOnline ? "Online" : (lastPoll ? "Offline" : "Ποτέ");
  const labelColor = isOnline ? "text-emerald-300" : (lastPoll ? "text-rose-300" : "text-zinc-500");
  return (
    <div
      className="flex flex-col gap-0.5"
      title={`Last poll: ${fmtDate(lastPoll)}\nLast receipt: ${fmtDate(lastReceipt)}\nReceipts σήμερα: ${receiptsToday}`}
    >
      <div className="flex items-center gap-2">
        <span className={`relative w-2.5 h-2.5 rounded-full ${dotColor} shadow-md ${ringColor}`}>
          {isOnline && (
            <span className="absolute inset-0 rounded-full bg-emerald-400 animate-ping opacity-75" />
          )}
        </span>
        <span className={`text-xs font-bold uppercase tracking-wider ${labelColor}`}>{label}</span>
      </div>
      <div className="text-[10px] text-zinc-500 font-mono leading-tight">
        {lastPoll ? fmtRelative(lastPoll) : "—"}
      </div>
      <div className="text-[10px] text-zinc-400 flex items-center gap-1 leading-tight">
        <Receipt size={9} className="text-amber-500" />
        <span className="font-mono font-bold text-zinc-200">{receiptsToday}</span>
        <span className="text-zinc-600">σήμερα</span>
      </div>
    </div>
  );
}
